import React, { useMemo, useState } from 'react';
import { notification, Button as Antdbutton } from 'antd';
import { useQuery } from 'react-query';
import { withRouter, RouteComponentProps, useHistory } from 'react-router-dom';
import DF from 'DisplayFramework';
import {
  AssetListSearchResponse,
  getAssetListByAnyRef,
  GetAssetListByAnyRefParams,
} from '../../services/assets';

import { getFinAssetListByAnyRef } from '../../services/finassets';
import { toCurrency } from 'utils/utils';
import DataGrid from 'components/DataGrid';
import ButtonComponent from 'components/Button';
import RouterLink from 'components/RouterLink';
import ParListSelect from 'components/ParListSelect';
import TasksListPopover from '../workflow/TasksListPopover';
import { DataGridColDef, DataGridProps } from 'components/DataGrid/DataGrid';
import { PlusOutlined } from '@ant-design/icons';
import IActions from 'icons/IActions';
import GetLabel from 'DisplayFramework/components/GetLabel';

type AssetListProps = RouteComponentProps &
  Pick<DataGridProps<any>, 'rowSelection'>;

const AssetList = (props: AssetListProps) => {
  const search = props.location.search;
  const params = new URLSearchParams(search);

  const phase = params.get('phase');
  const lphase = phase ? phase : 'PROPOSAL';
  const history = useHistory();
  const initialSearchParams: GetAssetListByAnyRefParams = {
    assetreference: '',
    clientname: '',
    clientreference: '',
    ctreference: '',
    deliveryreference: '',
    manufacturername: '',
    manufacturerreference: '',
    orderreference: '',
    propreference: '',
    refsupplier: '',
    assetlabel: '',
    suppliername: '',
    status: '',
    chassisno: '',
    plateno: '',
    assetclass: '',
  };

  localStorage.setItem('lphase', lphase);
  const searchphase = localStorage.getItem('lphase');
  const phases = searchphase ?? lphase;

  const [searchParams, setSearchParams] =
    useState<GetAssetListByAnyRefParams>(initialSearchParams);
  const [searchs, setsearchs] = useState(false);

  const {
    data: assets,
    isFetching,
    refetch,
  } = useAssets(searchParams, phases, searchs);
  const [datasource, setdatasource] = useState<any>([]);
  const columns = useMemo<DataGridColDef<AssetListSearchResponse>[]>(
    () => [
      {
        dataIndex: 'assetreference',
        filtrable: true,
        render: (assetreference, record) => {
          return (
            <RouterLink to={`/asset/${record.assetid}/${lphase}`}>
              {assetreference}
            </RouterLink>
          );
        },
        fixed: 'left',
        width: 150,
      },
      {
        dataIndex: 'assetlabel',
        filtrable: true,
        render: (assetlabel, record) => {
          return (
            <RouterLink to={`/asset/${record.assetid}/${lphase}`}>
              {assetlabel}
            </RouterLink>
          );
        },
        fixed: 'left',
        width: 300,
      },
      {
        dataIndex: 'status',
        filtrable: true,
        filterComponent: (
          <ParListSelect parcode="ASSETSTAT" style={{ width: '100%' }} />
        ),
        render: (val, record) => record.statuslabel,
        fixed: 'left',
        width: 120,
      },
      {
        dataIndex: 'chassisno',
        filtrable: true,
        width: 100,
      },
      {
        dataIndex: 'assetclass',
        filtrable: true,
        width: 100,
      },
      {
        dataIndex: 'plateno',
        filtrable: true,
        width: 100,
      },
      {
        dataIndex: 'propreference',
        filtrable: true,
        width: 150,
      },

      {
        dataIndex: 'refsupplier',
        filtrable: true,
        width: 150,
      },
      {
        dataIndex: 'suppliername',
        filtrable: true,
        width: 150,
      },
      {
        dataIndex: 'clientreference',
        filtrable: true,
        width: 150,
      },
      {
        dataIndex: 'clientname',
        filtrable: true,
        width: 150,
      },
      {
        dataIndex: 'manufacturerreference',
        filtrable: true,
        width: 170,
      },
      {
        dataIndex: 'manufacturername',
        filtrable: true,
        width: 170,
      },

      {
        dataIndex: 'assettypelabel',
        width: 150,
      },
      {
        dataIndex: 'assetcategorylabel',
        width: 200,
      },

      {
        dataIndex: 'assetorderreference',
        width: 100,
      },
      {
        dataIndex: 'assetdeliveryreference',
        width: 100,
      },

      {
        dataIndex: 'assetgrossamount',
        width: 150,
        align: 'right',
        render: (value, record) => toCurrency(value, record.currcode),
      },
      {
        dataIndex: 'assetnetamount',
        align: 'right',
        width: 130,
        fixed: 'right',
        render: (value, record) => toCurrency(value, record.currcode),
      },
      {
        comcode: 'actions',
        key: 'actions',
        fixed: 'right',
        width: 100,
        render: (record) => (
          <TasksListPopover
            entityId={record.assetid}
            entityName="ASSET"
            entityReference={record.assetreference}
            status={record?.assetstatus ?? ''}
            statusdate={record?.assetstatusdate ?? ''}
            onClose={refetch}
          >
            <Antdbutton
              size="small"
              icon={<IActions height="15px" width="15px" />}
            >
              <GetLabel label="actions" />
            </Antdbutton>
          </TasksListPopover>
        ),
      },
    ],
    [lphase, refetch]
  );
  const columnsProd = useMemo<DataGridColDef<AssetListSearchResponse>[]>(
    () => [
      {
        dataIndex: 'assetreference',
        filtrable: true,
        render: (assetreference, record) => {
          return (
            <RouterLink to={`/asset/${record.assetid}/${lphase}`}>
              {assetreference}
            </RouterLink>
          );
        },
        fixed: 'left',
        width: 150,
      },
      {
        dataIndex: 'ctreference',
        filtrable: true,
        width: 150,
      },

      {
        dataIndex: 'assetlabel',
        width: 150,
      },
      {
        dataIndex: 'status',
        filtrable: true,
        filterComponent: (
          <ParListSelect parcode="ASSETSTAT" style={{ width: '100%' }} />
        ),
        render: (val, record) => record.statuslabel,

        width: 120,
      },
      {
        dataIndex: 'chassisno',
        filtrable: true,
        width: 100,
      },
      {
        dataIndex: 'plateno',
        filtrable: true,
        width: 100,
      },
      {
        dataIndex: 'refsupplier',
        filtrable: true,
        width: 150,
      },
      {
        dataIndex: 'suppliername',
        filtrable: true,
        width: 150,
      },
      {
        dataIndex: 'clientreference',
        filtrable: true,
        width: 150,
      },
      {
        dataIndex: 'clientname',
        filtrable: true,
        width: 150,
      },

      {
        dataIndex: 'assettypelabel',
        width: 150,
      },
      {
        dataIndex: 'assetcategorylabel',
        width: 200,
      },

      {
        dataIndex: 'assetorderreference',
        width: 100,
      },
      {
        dataIndex: 'assetdeliveryreference',
        width: 100,
      },

      {
        dataIndex: 'assetgrossamount',
        width: 150,
        align: 'right',
        render: (value, record) => toCurrency(value, record.currcode),
      },
      {
        dataIndex: 'assetnetamount',
        align: 'right',
        width: 130,
        fixed: 'right',
        render: (value, record) => toCurrency(value, record.currcode),
      },
      {
        comcode: 'actions',
        key: 'actions',
        fixed: 'right',
        width: 100,
        render: (record) => (
          <TasksListPopover
            entityId={record.assetid}
            entityName="FINASSET"
            entityReference={record.assetreference}
            title={record.assetreference + ' - ' + record.assetlabel}
            status={record?.assetstatus ?? ''}
            statusdate={record?.assetstatusdate ?? ''}
            onClose={refetch}
            ctrid={record?.ctrid}
          >
            <Antdbutton
              size="small"
              icon={<IActions height="15px" width="15px" />}
            >
              <GetLabel label="actions" />
            </Antdbutton>
          </TasksListPopover>
        ),
      },
    ],
    [lphase, refetch]
  );

  return (
    <DF.Provider pagcode="assetlist">
      <DataGrid
        scroll={{ x: 1500, y: 400 }}
        titleComcode={phase === 'PROD' ? 'pageTitleProd' : 'pageTitleProposal'}
        pagination={{ pageSize: 50 }}
        dataSource={searchs === false ? datasource : assets}
        rowKey={(record) => record.assetid}
        columns={lphase === 'PROPOSAL' ? columns : columnsProd}
        hideExtraAction={lphase === 'PROD'}
        componentName="asset_list"
        onSearch={(values) => {
          setSearchParams({ ...values });
          setdatasource(assets);
          setsearchs(true);
          refetch();
        }}
        initialSearchValues={initialSearchParams}
        isLoading={isFetching}
        rowSelection={props.rowSelection}
        extraActions={
          <ButtonComponent
            onClick={() => history.push(`/asset/create/${lphase}`)}
            icon={<PlusOutlined />}
            type="primary"
            comcode="header.btnnew"
          />
        }
      />
    </DF.Provider>
  );
};

const useAssets = (searchParams: any, assetPhase: string, searchs: boolean) => {
  const assetsQuery = useQuery(
    ['getAssetListByAnyRef', searchParams],
    () =>
      getAssetListByAnyRef(searchParams)
        .then((res) => res.list || [])
        .catch((error) => {
          notification.error({
            description: error.message,
            message: 'Asset Service is not available',
          });
          return [];
        }),
    { enabled: assetPhase === 'PROPOSAL' && searchs }
  );
  const finAssetsQuery = useQuery(
    ['getFinAssetListByAnyRef', searchParams],
    () => getFinAssetListByAnyRef(searchParams).then((res) => res.list || []),
    { enabled: assetPhase === 'PROD' && searchs }
  );

  return assetPhase === 'PROPOSAL' ? assetsQuery : finAssetsQuery;
};

export default withRouter(AssetList);
